import React from "react";
import { Box, Editable, EditableInput, EditablePreview, } from "@chakra-ui/react";
import { EditableControls } from "./editable-controls";
import { Text } from "./text";
export function EditableText({ isDisabled = false, value, onCancel, onChange, onSubmit, ...props }) {
    return (React.createElement(Text, { ...props },
        React.createElement(Editable, { isPreviewFocusable: false, isDisabled: isDisabled, value: value, onCancel: onCancel, onChange: onChange, onSubmit: onSubmit },
            React.createElement(Box, { display: "flex", alignItems: "center", gap: 2 },
                React.createElement(EditablePreview, { p: 0 }),
                React.createElement(Box, { as: EditableInput, p: 0, outline: "none", borderRadius: 0, borderBottom: "1px", borderColor: "primary.border", width: "auto", _focusVisible: { boxShadow: "none" } }),
                React.createElement(EditableControls, { size: "sm" })))));
}
